import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61c38f56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "disk" }
const _hoisted_2 = { class: "diskicon" }
const _hoisted_3 = { class: "diskname" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "operations" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "arrow-icon" })
], -1))

import { computed } from 'vue'
import type { INetDrives } from '@remote/type/hezi'

interface IProps {
  disk: INetDrives
}
interface IEmits {
  (e: 'click', file: INetDrives): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    disk: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click', file: INetDrives): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  disk: INetDrives
}


const diskName = computed(() => props.disk.path)




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(["d_icon", __props.disk.type.toLowerCase()])
      }, null, 2)
    ]),
    _createElementVNode("div", {
      class: "diskinfo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click', __props.disk)))
    }, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(diskName)), 1)
    ]),
    _hoisted_4
  ]))
}
}

})